module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Bd.6e6ced3.woff2";